import * as Sentry from '@sentry/react'
import environment from 'config/environment'
import * as Types from '@sentry/types'

export const initSentry = () => {
  if (Sentry.isInitialized()) {
    return
  }

  const integrations: Types.Integration[] = [Sentry.browserTracingIntegration()]

  let config: Sentry.BrowserOptions = {}

  if (environment.isDev) {
    config = {
      beforeSend(event) {
        // Check if it is an exception, and if so, show the report dialog
        if (event.exception && event.event_id) {
          Sentry.showReportDialog({ eventId: event.event_id })
        }
        return event
      },
    }
  }

  if (import.meta.env.VITE_APP_SENTRY_ENABLED && window.location.hostname !== 'localhost') {
    Sentry.init({
      debug: !environment.isProd,
      dsn: environment.sentry.dsn,
      integrations,
      tracesSampleRate: environment.isProd ? 0.4 : 1.0,
      // VITE_PLUGIN_SENTRY_CONFIG n'est injecté que si vite-plugin-sentry est actif
      // (absent quand SENTRY_UPLOAD=false, ex. builds Docker) — ne doit pas crasher l'app.
      release: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG?.release,
      environment: environment.envName,
      ...config,
    })
  }
}
